import React, { useState, useContext, useRef, useEffect } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import CustomAvatar from "utils/CustomAvatar";
import AddUser from "client_config/lite/AddUser";
import { capitalize } from "lodash";

export default function AccountUsers(props) {
  const context = useContext(SettingsContext);

  let xIcon = require("images/lite/icons/x-close.svg");
  xIcon = <img className="remove-access-icon" alt="remove" src={`/datapulse${xIcon}`} />;

  const [users, setUsers] = useState(props.userType === "client" ? context.clientUsers : context.teamUsers);

  useEffect(() => {
    if (props.userType === "client") {
      setUsers(context.clientUsers);
    } else {
      setUsers(context.teamUsers);
    }
  }, [context.clientUsers, context.teamUsers, props.userType]);

  const handleRemoveUser = (email) => {
    if (props.userType === "client") {
      context.setClientUsers((prevUsers) => prevUsers.filter((user) => user.email !== email));
    } else {
      context.setTeamUsers((prevUsers) => prevUsers.filter((user) => user.email !== email));
    }
  };

  return (
    <div className="lite-client-access-container">
      <div className={props.userType === "client" ? "client-user-list" : "team-user-list"}>
        {users.map((user, index) => {
          let activeString = "";
          if (user.active === true) {
            activeString = "active";
          } else if (user.active === false) {
            activeString = "invited";
          }
          return (
            <React.Fragment key={index}>
              {props.userType === "client" ? (
                <div className="user-row">
                  <div className="client-box">
                    <input type="text" value={user.email} disabled />
                  </div>
                  <div className="close-x" onClick={() => handleRemoveUser(user.email)}>{xIcon}</div>
                  <div>
                    <p className={activeString}>{capitalize(activeString)}</p>
                  </div>
                </div>
              ) : (
                <div className="employee-box-y">
                  <CustomAvatar src={user.avatar ? user.avatar : ""} className="avatar" />
                  {user.name ? user.name : user.first_name + " " + user.last_name}
                  <div className="close-x" onClick={() => handleRemoveUser(user.email)}>{xIcon}</div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <AddUser userType={props.userType} />
    </div>
  );
}
